/**
 * @file PageIntro/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const BANNER_DERIVATIVE_WIDTHS = [300, 460, 620, 780, 1180];
export const BANNER_IMAGE_ASPECT_RATIO = "original";
